import { CrossmintPayButton } from "@crossmint/client-sdk-react-ui";
import {useEffect, useState} from "react";
import styled from "styled-components";
import confetti from "canvas-confetti";
import * as anchor from "@project-serum/anchor";
import {LAMPORTS_PER_SOL, PublicKey} from "@solana/web3.js";
import {useAnchorWallet} from "@solana/wallet-adapter-react";
import {WalletMultiButton} from "@solana/wallet-adapter-react-ui";
import {GatewayProvider} from '@civic/solana-gateway-react';
import Countdown from "react-countdown";
import {Snackbar, Paper, LinearProgress, Chip} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import {toDate, AlertState, getAtaForMint} from './utils';
import {MintButton} from './MintButton';
import {
    CandyMachine,
    awaitTransactionSignatureConfirmation,
    getCandyMachineState,
    mintOneToken,
    CANDY_MACHINE_PROGRAM,
} from "./candy-machine";

const cluster = process.env.REACT_APP_SOLANA_NETWORK!.toString();
const decimals = process.env.REACT_APP_SPL_TOKEN_TO_MINT_DECIMALS ? +process.env.REACT_APP_SPL_TOKEN_TO_MINT_DECIMALS!.toString() : 9;
const splTokenName = process.env.REACT_APP_SPL_TOKEN_TO_MINT_NAME ? process.env.REACT_APP_SPL_TOKEN_TO_MINT_NAME.toString() : "TOKEN";

const WalletContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
`;

const WalletAmount = styled.div`
  color: black;
  width: auto;
  padding-left: 10px;
  min-width: 48px;
  min-height: auto;
  border-radius: 5px;
  background-color: var(--main-text-color);
  box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%);
  box-sizing: border-box;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-weight: 500;
  line-height: 1.75;
  text-transform: uppercase;
  border: 0;
  margin: auto;
  display: inline-flex;
  outline: 0;
  position: relative;
  align-items: center;
  user-select: none;
  vertical-align: middle;
  justify-content: flex-start;
  gap: 10px;
`;

const Wallet = styled.ul`
  flex: 0 0 auto;
  margin-top: 10px auto;
  padding: 0;
  
`;

const ConnectButton = styled(WalletMultiButton)`
  border-radius: 5px !important;
  padding: 6px 16px;
  background-color: #dec328;
  margin: 0 auto;
  color: #000;
`;

const NFT = styled(Paper)`

  flex: 1 1 auto;
  background-color: var(--card-background-color) !important;

`;


const Card = styled(Paper)`
  display: inline-block;
  background-color: var(--card-background-lighter-color) !important;
  margin: 5px;
  padding: 24px;

`;

const MintButtonContainer = styled.div`
  button.MuiButton-contained:not(.MuiButton-containedPrimary).Mui-disabled {
    color: #464646;
  }
  margin: auto;
  
  button.MuiButton-contained:not(.MuiButton-containedPrimary):hover,
  button.MuiButton-contained:not(.MuiButton-containedPrimary):focus {
    -webkit-animation: pulse 1s;
    animation: pulse 1s;
    box-shadow: 0 0 0 2em rgba(255, 255, 255, 0);
  }

  @-webkit-keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 #dec328;
    }
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 #dec328;
    }
  }
`;

const SolExplorerLink = styled.a`
  color: var(--title-text-color);
  border-bottom: 1px solid var(--title-text-color);
  font-weight: bold;
  list-style-image: none;
  list-style-position: outside;
  list-style-type: none;
  outline: none;
  text-decoration: none;
  text-size-adjust: 100%;

  :hover {
    border-bottom: 2px solid var(--title-text-color);
  }
`;

const MainContainer = styled.div`
display: flex;
flex-direction: column;
text-align: center;
justify-content: center;
background-image: url(nordicGloryBG.jpg);
background-position: center;
width: 100% !important;
background-size: cover;
background-repeat: no-repeat;

`;

const MintContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  flex-wrap: wrap;
  gap: 20px;
  
`;

const DesContainer = styled.div`
width: 100%;

`;

const Price = styled(Chip)`
  position: absolute;
  margin: 5px;
  font-weight: bold;
  font-size: 1em !important;
  background-color: #dec328 !important;
  border-radius: 0px !important;
  color: #000 !important;
`;

// const Image = styled.img`
//   height: 400px;
//   width: auto;
//   border-radius: 7px;
//   box-shadow: 5px 5px 40px 5px rgba(0,0,0,0.5);
//   background-color: #fff;
// `;

const BorderLinearProgress = styled(LinearProgress)`
  margin: 20px 0;
  height: 10px !important;
  border-radius: 30px;
  border: 2px solid white;
  box-shadow: 5px 5px 40px 5px rgba(0,0,0,0.5);
  background-color:var(--main-text-color) !important;
  
  > div.MuiLinearProgress-barColorPrimary{
    background-color:var(--title-text-color) !important;
  }

  > div.MuiLinearProgress-bar1Determinate {
    border-radius: 30px !important;
    background-image: linear-gradient(270deg, rgba(255, 255, 255, 0.01), rgba(255, 255, 255, 0.5));
  }
`;



export interface HomeProps {
    candyMachineId: anchor.web3.PublicKey;
    connection: anchor.web3.Connection;
    txTimeout: number;
    rpcHost: string;
}

const Home = (props: HomeProps) => {
    const [balance, setBalance] = useState<number>();
    const [isMinting, setIsMinting] = useState(false); // true when user got to press MINT
    const [isActive, setIsActive] = useState(false); // true when countdown completes or whitelisted
    const [solanaExplorerLink, setSolanaExplorerLink] = useState<string>("");
    const [itemsAvailable, setItemsAvailable] = useState(0);
    const [itemsRedeemed, setItemsRedeemed] = useState(0);
    const [itemsRemaining, setItemsRemaining] = useState(0);
    const [isSoldOut, setIsSoldOut] = useState(false);
    const [payWithSplToken, setPayWithSplToken] = useState(false);
    const [price, setPrice] = useState(0);
    const [priceLabel, setPriceLabel] = useState<string>("SOL");
    const [whitelistPrice, setWhitelistPrice] = useState(0);
    const [whitelistEnabled, setWhitelistEnabled] = useState(false);
    const [whitelistTokenBalance, setWhitelistTokenBalance] = useState(0);
    const [isEnded, setIsEnded] = useState(false);
    const [endDate, setEndDate] = useState<Date>();

    const [alertState, setAlertState] = useState<AlertState>({
        open: false,
        message: "",
        severity: undefined,
    });

    const wallet = useAnchorWallet();
    const [candyMachine, setCandyMachine] = useState<CandyMachine>();

    const rpcUrl = props.rpcHost;

    const refreshCandyMachineState = () => {
        (async () => {
            if (!wallet) return;

            const cndy = await getCandyMachineState(
                wallet as anchor.Wallet,
                props.candyMachineId,
                props.connection
            );

            setCandyMachine(cndy);
            setItemsAvailable(cndy.state.itemsAvailable);
            setItemsRemaining(cndy.state.itemsRemaining);
            setItemsRedeemed(cndy.state.itemsRedeemed);

            var divider = 1;
            if (decimals) {
                divider = +('1' + new Array(decimals).join('0').slice() + '0');
            }

            // detect if using spl-token to mint
            if (cndy.state.tokenMint) {
                setPayWithSplToken(true);
                // Customize your SPL-TOKEN Label HERE
                // TODO: get spl-token metadata name
                setPriceLabel(splTokenName);
                setPrice(cndy.state.price.toNumber() / divider);
                setWhitelistPrice(cndy.state.price.toNumber() / divider);
            }else {
                setPrice(cndy.state.price.toNumber() / LAMPORTS_PER_SOL);
                setWhitelistPrice(cndy.state.price.toNumber() / LAMPORTS_PER_SOL);
            }


            // fetch whitelist token balance
            if (cndy.state.whitelistMintSettings) {
                setWhitelistEnabled(true);
                if (cndy.state.whitelistMintSettings.discountPrice !== null && cndy.state.whitelistMintSettings.discountPrice !== cndy.state.price) {
                    if (cndy.state.tokenMint) {
                        setWhitelistPrice(cndy.state.whitelistMintSettings.discountPrice?.toNumber() / divider);
                    } else {
                        setWhitelistPrice(cndy.state.whitelistMintSettings.discountPrice?.toNumber() / LAMPORTS_PER_SOL);
                    }
                }
                let balance = 0;
                try {
                    const tokenBalance =
                        await props.connection.getTokenAccountBalance(
                            (
                                await getAtaForMint(
                                    cndy.state.whitelistMintSettings.mint,
                                    wallet.publicKey,
                                )
                            )[0],
                        );

                    balance = tokenBalance?.value?.uiAmount || 0;
                } catch (e) {
                    console.error(e);
                    balance = 0;
                }
                setWhitelistTokenBalance(balance);
                setIsActive(!isEnded && balance > 0);
            } else {
                setWhitelistEnabled(false);
            }

            // end the mint when date is reached
            if (cndy?.state.endSettings?.endSettingType.date) {
                setEndDate(toDate(cndy.state.endSettings.number));
                if (
                    cndy.state.endSettings.number.toNumber() <
                    new Date().getTime() / 1000
                ) {
                    setIsEnded(true);
                    setIsActive(false);
                }
            }
            // end the mint when amount is reached
            if (cndy?.state.endSettings?.endSettingType.amount) {
                let limit = Math.min(
                    cndy.state.endSettings.number.toNumber(),
                    cndy.state.itemsAvailable,
                );
                setItemsAvailable(limit);
                if (cndy.state.itemsRedeemed < limit) {
                    setItemsRemaining(limit - cndy.state.itemsRedeemed);
                } else {
                    setItemsRemaining(0);
                    cndy.state.isSoldOut = true;
                    setIsEnded(true);
                }
            } else {
                setItemsRemaining(cndy.state.itemsRemaining);
            }

            if (cndy.state.isSoldOut) {
                setIsActive(false);
            }
        })();
    };

    const renderGoLiveDateCounter = ({days, hours, minutes, seconds}: any) => {
        return (
            <div><Card elevation={1}><h1>{days}</h1><br/>Days</Card><Card elevation={1}><h1>{hours}</h1>
                <br/>Hours</Card><Card elevation={1}><h1>{minutes}</h1><br/>Mins</Card><Card elevation={1}>
                <h1>{seconds}</h1><br/>Secs</Card></div>
        );
    };

    const renderEndDateCounter = ({days, hours, minutes}: any) => {
        let label = "";
        if (days > 0) {
            label += days + " days "
        }
        if (hours > 0) {
            label += hours + " hours "
        }
        label += (minutes+1) + " minutes left to MINT."
        return (
            <div><h3>{label}</h3></div>
        );
    };

    function displaySuccess(mintPublicKey: any): void {
        let remaining = itemsRemaining - 1;
        setItemsRemaining(remaining);
        setIsSoldOut(remaining === 0);
        if (whitelistTokenBalance && whitelistTokenBalance > 0) {
            let balance = whitelistTokenBalance - 1;
            setWhitelistTokenBalance(balance);
            setIsActive(!isEnded && balance > 0);
        }
        setItemsRedeemed(itemsRedeemed + 1);
        const solFeesEstimation = 0.012; // approx
        if (!payWithSplToken && balance && balance > 0) {
            setBalance(balance - (whitelistEnabled ? whitelistPrice : price) - solFeesEstimation);
        }
        setSolanaExplorerLink(cluster === "devnet" || cluster === "testnet"
            ? ("https://solscan.io/token/" + mintPublicKey + "?cluster=" + cluster)
            : ("https://solscan.io/token/" + mintPublicKey));
        throwConfetti();
    };

    function throwConfetti(): void {
        confetti({
            particleCount: 400,
            spread: 70,
            origin: {y: 0.6},
        });
    }

    const onMint = async () => {
        try {
            setIsMinting(true);
            if (wallet && candyMachine?.program && wallet.publicKey) {
                const mint = anchor.web3.Keypair.generate();
                const mintTxId = (
                    await mintOneToken(candyMachine, wallet.publicKey, mint)
                )[0];

                let status: any = {err: true};
                if (mintTxId) {
                    status = await awaitTransactionSignatureConfirmation(
                        mintTxId,
                        props.txTimeout,
                        props.connection,
                        'singleGossip',
                        true,
                    );
                }

                if (!status?.err) {
                    setAlertState({
                        open: true,
                        message: 'Congratulations! Mint succeeded!',
                        severity: 'success',
                    });

                    // update front-end amounts
                    displaySuccess(mint.publicKey);
                } else {
                    setAlertState({
                        open: true,
                        message: 'Mint failed! Please try again!',
                        severity: 'error',
                    });
                }
            }
        } catch (error: any) {
            // TODO: blech:
            let message = error.msg || 'Minting failed! Please try again!';
            if (!error.msg) {
                if (!error.message) {
                    message = 'Transaction Timeout! Please try again.';
                } else if (error.message.indexOf('0x138')) {
                } else if (error.message.indexOf('0x137')) {
                    message = `SOLD OUT!`;
                } else if (error.message.indexOf('0x135')) {
                    message = `Insufficient funds to mint. Please fund your wallet.`;
                }
            } else {
                if (error.code === 311) {
                    message = `SOLD OUT!`;
                } else if (error.code === 312) {
                    message = `Minting period hasn't started yet.`;
                }
            }

            setAlertState({
                open: true,
                message,
                severity: "error",
            });
        } finally {
            setIsMinting(false);
        }
    };


    useEffect(() => {
        (async () => {
            if (wallet) {
                const balance = await props.connection.getBalance(wallet.publicKey);
                setBalance(balance / LAMPORTS_PER_SOL);
            }
        })();
    }, [wallet, props.connection]);

    useEffect(refreshCandyMachineState, [
        wallet,
        props.candyMachineId,
        props.connection,
        isEnded
    ]);

    return (
		<main>
			<MainContainer>
				<WalletContainer>
					<div id="headerContainer">
						<div id="headerBlock">
							<div id="pageHeader">Nordic Glory</div>
							<div id="headerSubTitle1">
								A Collection of Viking Shields on the Solana
								Blockchain
								<br />
								<div id="headerSubTitle2">
									An Artist Collab Project on the Lost Skulls
									of Tyger Journey
								</div>
								<br />
							</div>
							<Wallet>
								{wallet ? (
									<WalletAmount>
										{(balance || 0).toLocaleString()} SOL
										<ConnectButton />
									</WalletAmount>
								) : (
									<ConnectButton>
										Connect Wallet
									</ConnectButton>
								)}
							</Wallet>
						</div>
					</div>
				</WalletContainer>
				{/* <ShimmerTitle>MINT IS LIVE !</ShimmerTitle> */}
				<br />

				<MintContainer>
					<MintButtonContainer>
						{!isActive &&
						!isEnded &&
						candyMachine?.state.goLiveDate ? (
							<Countdown
								date={toDate(candyMachine?.state.goLiveDate)}
								onMount={({ completed }) =>
									completed && setIsActive(!isEnded)
								}
								onComplete={() => {
									setIsActive(!isEnded);
								}}
								renderer={renderGoLiveDateCounter}
							/>
						) : !wallet ? (
							<ConnectButton>Connect Wallet</ConnectButton>
						) : candyMachine?.state.gatekeeper &&
						  wallet.publicKey &&
						  wallet.signTransaction ? (
							<GatewayProvider
								wallet={{
									publicKey:
										wallet.publicKey ||
										new PublicKey(CANDY_MACHINE_PROGRAM),
									//@ts-ignore
									signTransaction: wallet.signTransaction,
								}}
								// // Replace with following when added
								// gatekeeperNetwork={candyMachine.state.gatekeeper_network}
								gatekeeperNetwork={
									candyMachine?.state?.gatekeeper
										?.gatekeeperNetwork
								} // This is the ignite (captcha) network
								/// Don't need this for mainnet
								clusterUrl={rpcUrl}
								options={{ autoShowModal: false }}
							>
								<MintButton
									candyMachine={candyMachine}
									isMinting={isMinting}
									isActive={isActive}
									isEnded={isEnded}
									isSoldOut={isSoldOut}
									onMint={onMint}
								/>
							</GatewayProvider>
						) : (
							<MintButton
								candyMachine={candyMachine}
								isMinting={isMinting}
								isActive={isActive}
								isEnded={isEnded}
								isSoldOut={isSoldOut}
								onMint={onMint}
							/>
						)}

						{/* <CrossmintPayButton
							collectionTitle="Nordic Glory"
							collectionDescription="A collection of Viking shields meant to inspire others to pursue their dreams and achieve the glory they seek in life."
							collectionPhoto="https://uploads-ssl.webflow.com/617cc99e3b542fec0125ad93/622cfc3a50430095e5303992_logo.png"
							clientId="af587c82-bf72-44e3-80ff-bf2d1cf2d3a2"
							className="crossmintButton"
						/>
						<div className="disclaimer2">
							Purchase with SOL
							<br />
							to claim 3 for 1 offer
						</div> */}
						{wallet && isActive && (
							/* <p>Total Minted : {100 - (itemsRemaining * 100 / itemsAvailable)}%</p>}*/
							<h3 className="mintDetails">
								MINTS REMAINING : {itemsRemaining}
							</h3>
						)}
						{wallet &&
							isActive &&
							whitelistEnabled &&
							whitelistTokenBalance > 0 && (
								<h3>
									You own {whitelistTokenBalance}{" "}
									{whitelistTokenBalance > 1
										? "Tokens of Glory"
										: "Token of Glory"}
									.
								</h3>
							)}
					</MintButtonContainer>

					<DesContainer>
						<NFT elevation={3}>
							<div className="w-layout-grid nordic-grid">
								<div className="noridc-detail-box">
									<div className="nordic-detail-headline">
										HOW TO CLAIM THE 3 FOR 1 MINT:
									</div>
									<ul className="nordic-list">
										<li>
											<div>
												Mint 1 Nordic Glory for 0.75 SOL
											</div>
										</li>
										<li>
											<div>
												Fill out the 3 for 1 form below
											</div>
										</li>
										<li>
											<div>
												We will send 2 Free Mint Tokens!
											</div>
										</li>
										<li>
											<div>
												<em>
													<b>While supply lasts!</b>
												</em>
											</div>
										</li>
									</ul>
									<div className="disclaimer">
										<em>
											Tokens will send between 9AM-10PM
											CST
										</em>
									</div>
									<br />
									<div id="formLink">
										<a
											href="https://forms.gle/Pw6pDorujFt6e9J66"
											id="buttonForm"
											role="button"
											target="_blank"
											rel="noopener noreferrer"
										>
											3 for 1 Form
										</a>
									</div>
								</div>
								<div className="noridc-detail-box">
									<div className="nordic-detail-headline">
										HOW TO CLAIM THE lost gem SKULL of
										emerald
									</div>
									<ul className="nordic-list">
										<li>Mint a Cody Rostron Trait</li>
										<li>
											Go to the{" "}
											<b>Lost Skulls Event Page</b>
										</li>
										<li>Fill out the Form of Approval</li>
										<li>
											We'll send a token to mint the Skull
											of Emerald
										</li>
									</ul>
									<div id="formLink">
										<a
											href="https://www.skulloftyger.io/lost-skulls"
											id="buttonForm"
											role="button"
											target="_blank"
											rel="noopener noreferrer"
										>
											Lost Skulls of Tyger
										</a>
									</div>
								</div>
								<div className="noridc-detail-box">
									<div className="nordic-detail-headline">
										10 EPIC SHIELDS!
									</div>
									<ul className="nordic-list">
										<li>
											<span id="number">1 1/1</span> Epic
											Shield of Tyger
										</li>
										<li>
											<span id="number">9 1/1</span> Epic
											Cross-Promo Shields
										</li>
										<li>
											Mint one and receive a Free NFT from
											the corresponding collection
										</li>
									</ul>
									<div
										className="nordic-detail-headline"
										style={{ marginBottom: "10px" }}
									>
										<span style={{ color: "white" }}>
											NEW!{" "}
										</span>
										5 Shields of Mischief
									</div>
									<div id="formLink">
										<a
											className="align"
											href="https://www.tylermcnair.com/nordic-glory-nft"
											id="buttonForm"
											role="button"
											target="_blank"
											rel="noopener noreferrer"
										>
											View Details
										</a>
									</div>
								</div>
							</div>
							<div id="heroSpace">
								<Price
									label={
										isActive &&
										whitelistEnabled &&
										whitelistTokenBalance > 0
											? whitelistPrice + " " + priceLabel
											: price + " " + priceLabel
									}
								/>
								<img
									className="hero"
									src="Nordic-Glory.gif"
									alt="Nordic Glory"
								/>
							</div>
							<br />
							{wallet &&
								isActive &&
								endDate &&
								Date.now() < endDate.getTime() && (
									<Countdown
										date={toDate(
											candyMachine?.state?.endSettings
												?.number
										)}
										onMount={({ completed }) =>
											completed && setIsEnded(true)
										}
										onComplete={() => {
											setIsEnded(true);
										}}
										renderer={renderEndDateCounter}
									/>
								)}
							{wallet && isActive && (
								<BorderLinearProgress
									variant="determinate"
									value={100 - (itemsRemaining * 100) / 2105}
								/>
							)}
							<br />
							<br />
							{wallet && isActive && solanaExplorerLink && (
								<SolExplorerLink
									href={solanaExplorerLink}
									target="_blank"
								>
									View on Solscan
								</SolExplorerLink>
							)}
							<br />
							Official Discord
							<br />{" "}
							<a
								href="https://discord.com/invite/v6esK9eND8"
								target="_blank"
								rel="noopener noreferrer"
							>
								<img
									alt="Visit The Discord"
									src="white_discord.png"
								/>
							</a>
						</NFT>
					</DesContainer>
					{/* <DesContainer>
                        <Des elevation={2}>
                            <LogoAligner><img src="logo.png" alt=""></img><GoldTitle>TITLE 1</GoldTitle></LogoAligner>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                incididunt.</p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                incididunt.</p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                incididunt.</p>
                        </Des>
                        <Des elevation={2}>
                            <LogoAligner><img src="logo.png" alt=""></img><GoldTitle>TITLE 2</GoldTitle></LogoAligner>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                incididunt.</p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                incididunt.</p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                incididunt.</p>
                        </Des>
                        <Des elevation={2}>
                            <LogoAligner><img src="logo.png" alt=""></img><GoldTitle>TITLE 3</GoldTitle></LogoAligner>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                incididunt.</p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                incididunt.</p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                incididunt.</p>
                        </Des>
                    </DesContainer> */}
				</MintContainer>
			</MainContainer>
			<Snackbar
				open={alertState.open}
				autoHideDuration={6000}
				onClose={() => setAlertState({ ...alertState, open: false })}
			>
				<Alert
					onClose={() =>
						setAlertState({ ...alertState, open: false })
					}
					severity={alertState.severity}
				>
					{alertState.message}
				</Alert>
			</Snackbar>
		</main>
	);
};

export default Home;
